import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import CloseIcon from '@material-ui/icons/Close';

import CircularProgress from '@material-ui/core/CircularProgress';

import * as d3 from 'd3';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

//import Calendar from 'react-calendar/dist/entry.nostyle';
import Calendar from 'react-calendar';
//import YearView from 'react-calendar';
//import DecadeView from 'react-calendar';

const styles = theme => ({
  card: {
    display: 'flex column',
    margin: 0,
    borderColor: 'rgba(255,255,255,0)!important',
    boxShadow: '0px 0px 0px 0px rgba(255,255,255,0)!important',
    backgroundColor: '#f3f3f3',
  },
  cardHeader: {
    backgroundColor: '#069999',
    color: '#fff',
    padding: '10px',
    fontFamily: 'Nunito Sans SemiBold!important',
    textAlign: 'left',
    fontSize: '16pt',
    borderRadius: '10px',
    minHeight: '80px',
    maxHeight: '80px',
  },
  cardContent: {
    padding: '0!important',
    marginTop: '20px;',
    minHeight: '390px',
    height: '390px',
    fontSize: '1.2em',

  },
  header: {
    paddingLeft: '20px',
    textAlign: 'left',
  },
  title: {
    fontFamily: 'Nunito Sans Regular!important',
    fontSize: '14pt',
    color: '#08716e',
  },
  statBlock: {
    fontFamily: 'Nunito Sans Regular!important',
    fontSize: '14pt',
    color: '#4d4c4c',
    paddingLeft: '30px',
    textAlign: 'left',
  },
  highlight: {
    fontFamily: 'Nunito Sans Bold!important',
  },
  footnote: {
    paddingLeft: '20px',
    textAlign: 'left',
    fontSize:'12pt',
  },
});

function parseDate(input) {
  var parts = input.match(/(\d+)/g);
  // note parts[1]-1
  return new Date(parts[2], parts[1] - 1, parts[0]);
}

function CalendarBlockCard(props) {
  const { classes } = props;

  //https://github.com/d3/d3-time-format#timeFormatDefaultLocale
  //https://stackoverflow.com/questions/19274464/how-to-make-localization-on-months-days-for-d3js

  let locale
  switch (props.lang) {
    case "de":
      locale = d3.timeFormatDefaultLocale({
        "decimal": ",",
        "thousands": ".",
        "grouping": [3],
        "currency": ["€", ""],
        "dateTime": "%a %b %e %X %Y",
        "date": "%d-%m-%Y",
        "time": "%H:%M:%S",
        "periods": ["AM", "PM"],
        "days": ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
        "shortDays": ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        "months": ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
        "shortMonths": ["Jan", "", "Mar", "", "Mai", "", "Jul", "", "Sep", "", "Nov", ""]
      })
      break;
    case "en":
      locale = d3.timeFormatDefaultLocale({
        "decimal": ",",
        "thousands": ".",
        "grouping": [3],
        "currency": ["€", ""],
        "dateTime": "%a %b %e %X %Y",
        "date": "%d-%m-%Y",
        "time": "%H:%M:%S",
        "periods": ["AM", "PM"],
        "days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "shortDays": ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        "months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        "shortMonths": ["Jan", "", "Mar", "", "May", "", "Jul", "", "Sep", "", "Nov", ""]
      })
      break;
    case "fr":
    default:
      locale = d3.timeFormatDefaultLocale({
        "decimal": ",",
        "thousands": ".",
        "grouping": [3],
        "currency": ["€", ""],
        "dateTime": "%a %b %e %X %Y",
        "date": "%d-%m-%Y",
        "time": "%H:%M:%S",
        "periods": ["AM", "PM"],
        "days": ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
        "shortDays": ["Di", "Lu", "Ma", "Mi", "Je", "Ve", "Sa"],
        "months": ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
        "shortMonths": ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"]
      })
  }

  let energyType
  switch (props.lang) {
    case "de":
      energyType = (
        props.currentTech.solar ? (
          props.currentTech.wind ? (
            props.currentTech.windOffshore ?
              "Solar-, Onshore- und Offshore-Wind"
              : "Solar- und Onshore-Wind"
          )
            : (
              props.currentTech.windOffshore ?
                "Solar- und Offshore-Wind"
                : "Solar"
            )
        )
          : (
            props.currentTech.wind ? (
              props.currentTech.windOffshore ?
                "Onshore- und Offshore-Wind" :
                "Onshore-Wind"
            )
              : "Offshore-Wind"
          )
      )
      break
    case "en":
      energyType = (
        props.currentTech.solar ? (
          props.currentTech.wind ? (
            props.currentTech.windOffshore ?
              "Solar,onshore and offshore wind"
              : "Solar and onshore wind"
          )
            : (
              props.currentTech.windOffshore ?
                "Solar and offshore wind"
                : "Solar"
            )
        )
          : (
            props.currentTech.wind ? (
              props.currentTech.windOffshore ?
                "Onshore and offshore wind" :
                "Onshore wind"
            )
              : "Offshore wind"
          )
      )
      break
    case "fr":
    default:
      energyType = (
        props.currentTech.solar ? (
          props.currentTech.wind ? (
            props.currentTech.windOffshore ?
              "solaire, éolienne onshore et offshore"
              : "solaire et éolienne onshore"
          )
            : (
              props.currentTech.windOffshore ?
                "solaire et éolienne offshore"
                : "solaire"
            )
        )
          : (
            props.currentTech.wind ? (
              props.currentTech.windOffshore ?
                "éolienne onshore et offshore" :
                "éolienne onshore"
            )
              : "éolienne offshore"
          )
      )
  }

  let cardHeaderTitle
  let dateInfo
  if (props.currentMode === 'realtime') {
    let formattedDay
    switch (props.lang) {
      case "de":
        formattedDay = d3.timeFormat('%e. %B %Y')(props.selectedDate)
        dateInfo = "am " + formattedDay
        break
      case "en":
        formattedDay = d3.timeFormat('%e %B %Y')(props.selectedDate)
        dateInfo = formattedDay
        break
      case "fr":
      default:
        formattedDay = d3.timeFormat('%e %B %Y')(props.selectedDate)
        dateInfo = " le " + formattedDay
    }
  }
  else {
    let formattedYear = props.yearSelected
    dateInfo = " le " + formattedYear
  }
  switch (props.lang) {
    case "de":
      //cardHeaderTitle = energyType + "energie Aufzeichnungen im Vergleich zur Nachfrage seit 2015"
      cardHeaderTitle = energyType + "energie Spitzenleistungen seit 2015"
      break
    case "en":
      //cardHeaderTitle = energyType + " energy records relative to the demand since 2015"
      cardHeaderTitle = energyType + " energy production records since 2015"
      break
    case "fr":
    default:
      //cardHeaderTitle = "Records d\'énergie " + energyType + " par raport à la demande depuis 2015"
      cardHeaderTitle = "Records de production d\'énergie " + energyType + " depuis 2015"
  }


  let dayRecordProduction
  let dayRecordCoveredDemand
  let topDays
  let energyPeak

  let ofTheTotalDemand
  let ofTheDemandAt

  if (props.currentTech !== undefined && props.dataLoaded && props.currentTech && props.currentTech.hasOwnProperty('solar')) {
    let topDaysData = (props.currentTech.solar ? (
      props.currentTech.wind ? (
        props.currentTech.windOffshore ? props.calendarStats.top_days.all : props.calendarStats.top_days.combined
      ) :
        props.currentTech.windOffshore ? props.calendarStats.top_days.solar_offshore : props.calendarStats.top_days.solar
    ) : (
        props.currentTech.wind ? (
          props.currentTech.windOffshore ? props.calendarStats.top_days.wind_wind : props.calendarStats.top_days.wind
        ) : props.calendarStats.top_days.wind_offshore
      )
    );
    let energyPeakData = (props.currentTech.solar ? (
      props.currentTech.wind ? (
        props.currentTech.windOffshore ? props.calendarStats.energy_peak.all : props.calendarStats.energy_peak.combined
      ) :
        props.currentTech.windOffshore ? props.calendarStats.energy_peak.solar_offshore : props.calendarStats.energy_peak.solar
    ) : (
        props.currentTech.wind ? (
          props.currentTech.windOffshore ? props.calendarStats.energy_peak.wind_wind : props.calendarStats.energy_peak.wind
        ) : props.calendarStats.energy_peak.wind_offshore
      )
    );


    
    
    switch (props.lang) {
      case "de":
        dayRecordProduction = `Tägliche Produktionsspitze am ${d3.timeFormat('%e %B %Y')(new Date(parseDate(topDaysData.date)))}`
        dayRecordCoveredDemand = `Stündliche Produktionsspitze am ${d3.timeFormat('%e %B %Y')(new Date(parseDate(energyPeakData.date)))} um ${energyPeakData.time.substring(0, 2)} Uhr`
        ofTheTotalDemand = " der Gesamtnachfrage wird durch die Produktion gedeckt "
        ofTheDemandAt = ` der Nachfrage wird durch die Produktion um ${energyPeakData.time.substring(0, 2)} Uhr `
        break
      case "en":
        dayRecordProduction = `Daily peak on ${d3.timeFormat('%e %B %Y')(new Date(parseDate(topDaysData.date)))}`
        dayRecordCoveredDemand = `Hourly peak on ${d3.timeFormat('%e %B %Y')(new Date(parseDate(energyPeakData.date)))} at ${energyPeakData.time.substring(0, 2)}h`
        ofTheTotalDemand = " of the total daily demand is covered by the production "
        ofTheDemandAt = ` of the demand is covered by the production at ${energyPeakData.time.substring(0, 2)}h `
        break
      case "fr":
      default:
        dayRecordProduction = `Pic journalier le ${d3.timeFormat('%e %B %Y')(new Date(parseDate(topDaysData.date)))}`
        dayRecordCoveredDemand = `Pic horaire le ${d3.timeFormat('%e %B %Y')(new Date(parseDate(energyPeakData.date)))} à ${energyPeakData.time.substring(0, 2)}h`
        ofTheTotalDemand = " de la demande totale journalière était couverte par la production "
        ofTheDemandAt = ` de la demande était couverte par la production à ${energyPeakData.time.substring(0, 2)}h `
    }


    topDays = {
      label: topDaysData.label[props.lang].replace(/^\w/, c => c.toUpperCase()),
      text: topDaysData.text === "Niet beschikbaar" ?
        (<div><span className={'classes.title'}>{topDaysData.text}</span></div>) :
        (
          <div className={classes.statBlock}>
            <div>
              <span>{topDaysData.percentage.value.toLocaleString('nl-BE')}{topDaysData.percentage.unit}</span>
              {ofTheTotalDemand} <span>({(Math.round(topDaysData.energy.value / 100) / 10).toLocaleString('nl-BE')} GWh)</span>
            </div>
          </div>
        )
    }
    energyPeak = {
      label: energyPeakData.label[props.lang].replace(/^\w/, c => c.toUpperCase()),
      text: energyPeakData.text === "Niet beschikbaar" ?
        (<div><span className={'classes.title'}>{energyPeakData.text}</span></div>) :
        (
          <div className={classes.statBlock}>
            <div>
              <span>{energyPeakData.percentage.value.toLocaleString('nl-BE')}{energyPeakData.percentage.unit}</span>
              {ofTheDemandAt}<span>({(Math.round(energyPeakData.energy.value / 100) / 10).toLocaleString('nl-BE')} GWh)</span>
            </div>
          </div>
        )
    }
  }
  return (
    <Card className={classes.card}>
      <CardHeader
        className={classes.cardHeader}
        disableTypography
        title={cardHeaderTitle}
      />
      {
        props.dataLoaded ? (
          <CardContent className={classes.cardContent}>
            <p className={classes.header + " mediumgreen"}>
              {dayRecordProduction}
            </p>
            <span className="darkgrey">{topDays.text}</span>

            <p className={classes.header + " mediumgreen"}>
              {dayRecordCoveredDemand}
            </p>
            <span className="darkgrey">{energyPeak.text}</span>
          </CardContent>
        ) : (
            <CardContent className={classes.cardContent}>
              <CircularProgress className={classes.progress} size={50} />
            </CardContent>
          )

      }


    </Card >
  );
}




CalendarBlockCard.propTypes = {
  classes: PropTypes.object.isRequired,
  selectedDate: PropTypes.object,
  selectedYear: PropTypes.number.isRequired,
  currentTech: PropTypes.object.isRequired,
  currentMode: PropTypes.string.isRequired,
  calendarStats: PropTypes.object.isRequired,
  dataLoaded: PropTypes.bool.isRequired,
};

export default withStyles(styles)(CalendarBlockCard);
